// src/screen-reader-only.tsx
import { jsx } from "react/jsx-runtime";
var ScreenReaderOnly = ({
  show = true,
  children
}) => show ? /* @__PURE__ */ jsx("span", { className: "sr-only", children }) : null;

export {
  ScreenReaderOnly
};
